import {
  PROJECT_VISIBILITY_VALUES,
  schema,
} from '@edgevanta/db/drizzle/client';
import { createInsertSchema, createSelectSchema } from 'drizzle-zod';
import { z } from 'zod/v4';
import { createQuerySchemaWithPagination } from '../shared';

export const selectProjectSchema = createSelectSchema(schema.projects, {
  visibility: z.enum(PROJECT_VISIBILITY_VALUES),
});

export const insertProjectSchema = createInsertSchema(schema.projects, {
  description: z.string().max(2048).optional(),
  name: z.string().max(255).min(1),
  visibility: z.enum(PROJECT_VISIBILITY_VALUES),
}).omit({
  organizationId: true,
});

export const updateProjectSchema = insertProjectSchema.partial().extend({
  id: z.string(),
  organizationId: z.string().uuid(),
});

const ProjectsQuerySchema = z.object({
  search: z.string().optional(),
  name: z.string().optional(),
  userId: z.string().uuid(),
  visibility: z
    .string()
    .optional()
    .transform((val) => {
      if (!val) {
        return [];
      }

      return val.split(',').map((visibility) => visibility);
    })
    .default([]),
  createdAt: z
    .string()
    .optional()
    .transform((val) => {
      if (!val) {
        return [];
      }

      return val.split(',').map((num) => Number(num));
    })
    .default([]),
});

export const getProjectsQuerySchema = createQuerySchemaWithPagination(
  ProjectsQuerySchema,
  { id: 'name', desc: false },
).merge(
  z.object({
    limit: z.coerce.number().optional().default(10),
  }),
);

export const getProjectsCountQuerySchema = ProjectsQuerySchema;
